import actionTypes from './action_types';
import fetchJsonapi from './api';

export const switchLanguage = (language = "en", country = "us") => async (dispatch) => {
  try {
    const result = await fetchJsonapi(language, country);
    dispatch({
      type: actionTypes.SWITCH_LANGUAGE,
      payload: JSON.parse(result)
    });
  } catch (error) {
  }
};



// WEBPACK FOOTER //
// ./src/mi-app/language/actions.js